import { LayoutDashboard, TrendingUp, History, Trophy, LogOut } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

export function EZ5050Sidebar({ openPositionsCount = 0, onLogoutClick }) {
  const location = useLocation();
  const navigate = useNavigate();
  
  const pathname = location.pathname;
  const activeTab = pathname.includes('/dashboard') ? 'dashboard' :
                    pathname.includes('/futures') ? 'trade' :
                    pathname.includes('/history') ? 'history' :
                    pathname.includes('/leaderboard') ? 'leaderboard' : '';

  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, path: '/dashboard' },
    { id: 'trade', label: 'Trade', icon: TrendingUp, path: '/futures/up-down', badge: openPositionsCount > 0 ? openPositionsCount : undefined },
    { id: 'history', label: 'History', icon: History, path: '/history' },
    { id: 'leaderboard', label: 'Leaderboard', icon: Trophy, path: '/leaderboard' },
  ];

  return (
    <aside className="flex flex-col justify-between py-4 select-none shrink-0 h-full"
      style={{ width: '180px', background: '#0e121a', borderRight: '1px solid #1e2638' }}>
      <div className="space-y-1.5 px-3">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className="w-full flex items-center space-x-3 px-3 py-3 rounded-xl transition-all cursor-pointer font-medium text-sm"
              style={{
                background: isActive ? '#1e2738' : 'transparent',
                color: isActive ? 'white' : '#94a3b8',
                border: isActive ? '1px solid rgba(59,71,93,0.6)' : '1px solid transparent',
                boxShadow: isActive ? '0 10px 15px -3px rgba(0,0,0,0.1)' : 'none',
              }}
            >
              <div className="relative">
                <Icon className="w-5 h-5" style={{ color: isActive ? '#fbbf24' : '#94a3b8' }} />
                {item.badge !== undefined && (
                  <span className="absolute -top-1 -right-1.5 text-black text-[10px] font-extrabold w-4 h-4 rounded-full flex items-center justify-center animate-pulse"
                    style={{ background: '#10b981' }}>
                    {item.badge}
                  </span>
                )}
              </div>
              <span className="font-semibold">{item.label}</span>
            </button>
          );
        })}
      </div>

      {/* Footer Info */}
      <div className="px-3 space-y-3">
        <div className="rounded-xl p-3 text-xs"
          style={{ background: '#131a26', border: '1px solid #1e293b', color: '#94a3b8' }}>
          <div className="font-bold mb-1 flex items-center justify-between" style={{ color: '#e2e8f0' }}>
            <span>EZ5050 Engine</span>
            <span className="text-[10px] px-1.5 py-0.5 rounded"
              style={{ background: 'rgba(16,185,129,0.2)', color: '#34d399' }}>v2.4</span>
          </div>
          <p className="text-[11px] leading-relaxed" style={{ color: '#94a3b8' }}>
            50/50 Binary Trading with live candlestick indicators & instant settlement.
          </p>
        </div>
        
        <button
          onClick={onLogoutClick}
          className="w-full flex items-center justify-center space-x-2 py-2.5 rounded-lg text-xs font-bold transition-colors hover:text-white"
          style={{ background: '#18202f', color: '#94a3b8', border: '1px solid #1e293b' }}
        >
          <LogOut className="w-4 h-4" />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}
